export default __webpack_public_path__ + "static/media/clumsy.b2016b95.png";